/* =============================================================================
   Cherry Tuning — shared behaviour for all .cy components.
   Loaded once site-wide from layout/theme.liquid (defer).
   - .cy-rv  : reveal-on-scroll (respects reduced-motion)
   - .cy-acc : accordion group — opening one <details> closes its siblings
   Re-runs on shopify:section:load so it works in the theme editor too.
   ============================================================================= */
(function(){
  var REDUCED = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function revealIn(scope){
    var items = [].slice.call((scope || document).querySelectorAll('.cy-rv:not(.in)'));
    if(!items.length) return;
    if(REDUCED || !('IntersectionObserver' in window)){
      items.forEach(function(el){ el.classList.add('in'); });
      return;
    }
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -7% 0px' });
    items.forEach(function(el, i){ el.style.transitionDelay = ((i % 5) * 40) + 'ms'; io.observe(el); });
  }

  function wireAccordions(scope){
    [].slice.call((scope || document).querySelectorAll('.cy-acc')).forEach(function(group){
      if(group.dataset.cyAcc) return;            // don't double-wire
      group.dataset.cyAcc = '1';
      var items = [].slice.call(group.querySelectorAll('details'));
      items.forEach(function(d){
        d.addEventListener('toggle', function(){
          if(d.open){ items.forEach(function(o){ if(o !== d) o.open = false; }); }
        });
      });
    });
  }

  function init(scope){ revealIn(scope); wireAccordions(scope); }

  if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', function(){ init(document); }); }
  else { init(document); }

  // Theme editor: a section just got (re)loaded — wire only that section.
  document.addEventListener('shopify:section:load', function(e){ init(e.target); });
})();

/* ---- Cherry wishlist + Cherry Rewards (replace Growave) ----
   Logged in: lists live on the customer record (metafields), written through the app proxy /apps/cherry/wishlist
   (Cloud Run backend; Shopify signs each request with the logged-in customer). Guest: one list in localStorage
   ('cyWishlist'), folded into the account the first time they browse logged in.
   Hooks: [data-cy-wl][data-id] toggles (hearts + product button) · [data-cy-wl-pick] list picker ·
   [data-cy-wishlist-count] header bubble · #cy-wishlist-root the wishlist page (?share=TOKEN = a shared list). */
(function(){
  var API = '/apps/cherry/wishlist', SHARE_API = '/apps/cherry/share', KEY = 'cyWishlist', MAX_LISTS = 20;
  var HEART = '<svg viewBox="0 .3 22 20" aria-hidden="true" focusable="false"><path d="M11 18.6S2 13.3 2 7.5C2 4.5 4.3 2 7.2 2c1.7 0 3 .9 3.8 2.2C11.8 2.9 13.1 2 14.8 2 17.7 2 20 4.5 20 7.5c0 5.8-9 11.1-9 11.1z"/></svg>';
  var S = {}; try { S = JSON.parse(document.getElementById('cy-wl-state').textContent) || {}; } catch(e){}
  var IN = !!S.in, queue = Promise.resolve(), base = {}, was = {}, handles = {}, data = null, active = null, shareMode = false;
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function now(){ return Math.floor(Date.now() / 1000); }
  function esc(s){ return String(s == null ? '' : s).replace(/[&<>"']/g, function(c){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]; }); }
  function fresh(){ return [{id:'main', name:'My wishlist', items:[]}]; }
  function guest(){ try { return JSON.parse(localStorage.getItem(KEY) || '{}') || {}; } catch(e){ return {}; } }
  function guestSave(g){ try { if(Object.keys(g).length) localStorage.setItem(KEY, JSON.stringify(g)); else localStorage.removeItem(KEY); } catch(e){} }
  function fromGuest(){ var g = guest(); return [{id:'main', name:'My wishlist', items: Object.keys(g).map(function(id){ handles[+id] = g[id].handle; return [+id, g[id].at || 0]; }).sort(function(a, b){ return b[1] - a[1]; })}]; }
  var lists = IN ? ((S.lists && S.lists.lists && S.lists.lists.length) ? S.lists.lists : fresh()) : fromGuest();
  var legacy = IN && S.lists && S.lists.legacy ? S.lists.legacy : [];   // old Growave saves on products no longer sold online (snapshots)

  function has(l, pid){ return l.items.some(function(it){ return it[0] === pid; }); }
  function saved(pid){ return lists.some(function(l){ return has(l, pid); }); }
  function total(){ var s = {}; lists.forEach(function(l){ l.items.forEach(function(it){ s[it[0]] = 1; }); }); return Object.keys(s).length; }
  function setText(el, t){ if(el.textContent !== t) el.textContent = t; }

  /* every heart, product button and header bubble on the page */
  function paint(scope){
    [].forEach.call((scope || document).querySelectorAll('[data-cy-wl][data-id]'), function(b){
      var pid = +b.getAttribute('data-id'), on = saved(pid);
      if(b.getAttribute('data-handle')) handles[pid] = b.getAttribute('data-handle');
      b.classList.toggle('is-saved', on);
      if(b.getAttribute('aria-pressed') !== String(on)) b.setAttribute('aria-pressed', String(on));
      var lbl = b.querySelector('[data-cy-wl-lbl]'); if(lbl) setText(lbl, on ? 'Saved to wishlist' : 'Add to wishlist');
      var n = b.querySelector('[data-cy-wl-n]');
      if(n){
        if(!(pid in base)){ base[pid] = +n.getAttribute('data-count') || 0; was[pid] = on; }
        var c = base[pid] + (IN ? (on ? 1 : 0) - (was[pid] ? 1 : 0) : 0);   // guests are not counted server-side
        setText(n, c > 0 ? '(' + c + ')' : '');
      }
    });
    var t = total();
    [].forEach.call(document.querySelectorAll('[data-cy-wishlist-count]'), function(el){ setText(el, String(t)); el.style.display = t ? '' : 'none'; });
  }

  var toastEl, toastT;
  function toast(msg){
    if(!toastEl){ toastEl = document.createElement('div'); toastEl.className = 'cy-wl-toast'; toastEl.setAttribute('role', 'status'); toastEl.setAttribute('aria-live', 'polite'); document.body.appendChild(toastEl); }
    toastEl.textContent = msg; toastEl.classList.add('is-on'); clearTimeout(toastT);
    toastT = setTimeout(function(){ toastEl.classList.remove('is-on'); }, 3000);
  }
  function oops(e){ toast(e && e.message === 'wishlist full' ? 'Your wishlist is full (128 items). Remove something first.' : "Couldn't update your wishlist. Please try again."); }

  /* one request at a time, in tap order */
  function send(body, url){
    var p = queue.then(function(){
      return fetch(url || API, {method:'POST', credentials:'same-origin', headers:{'Content-Type':'application/json', 'Accept':'application/json'}, body: JSON.stringify(body)})
        .then(function(r){ return r.json().catch(function(){ return {}; }).then(function(j){ if(!r.ok || !j.ok){ var e = new Error(j.error || ('HTTP ' + r.status)); e.status = r.status; throw e; } return j; }); });
    });
    queue = p.catch(function(){});
    return p;
  }
  function took(j){
    if(j.lists) lists = j.lists;
    if(j.legacy) legacy = j.legacy;
    Object.keys(j.counts || {}).forEach(function(k){ if(j.counts[k] != null){ base[+k] = j.counts[k]; was[+k] = saved(+k); } });
    paint(); renderPage(); pickCounts();
  }
  function snapshot(){ return JSON.stringify(lists); }
  function restore(s){ lists = JSON.parse(s); paint(); renderPage(); pickCounts(); }

  /* heart / product button */
  function toggle(btn){
    var pid = +btn.getAttribute('data-id'); if(!pid) return;
    if(IN && lists.length > 1) return pick(pid);
    var on = !saved(pid), before = snapshot();
    if(on) lists[0].items.unshift([pid, now()]); else lists.forEach(function(l){ l.items = l.items.filter(function(it){ return it[0] !== pid; }); });
    paint(); renderPage();
    if(!IN){
      var g = guest();
      if(on){ g[pid] = {handle: btn.getAttribute('data-handle') || handles[pid], at: now()}; } else { delete g[pid]; }
      guestSave(g);
      var hinted = false; try { hinted = sessionStorage.getItem('cyWlHint'); sessionStorage.setItem('cyWlHint', '1'); } catch(e){}
      toast(!on ? 'Removed from your wishlist' : hinted ? 'Saved to your wishlist' : 'Saved on this device. Log in to keep it on your account.');
      return;
    }
    send({op: on ? 'add' : 'remove', pid: pid})
      .then(function(j){ took(j); toast(on ? 'Saved to your wishlist' : 'Removed from your wishlist'); })
      .catch(function(e){ restore(before); oops(e); });
  }

  /* list picker - logged-in customers */
  var dlg;
  function pick(pid){
    if(!IN) return;
    if(!dlg){
      dlg = document.createElement('dialog'); dlg.className = 'cy-wl-dlg'; dlg.setAttribute('aria-labelledby', 'cy-wl-dlg-t'); document.body.appendChild(dlg);
      dlg.addEventListener('click', function(e){ if(e.target === dlg || (e.target.closest && e.target.closest('[data-close]'))) dlg.close(); });
      dlg.addEventListener('change', function(e){ var cb = e.target.closest('input[data-list]'); if(cb) member(+dlg.getAttribute('data-pid'), cb.getAttribute('data-list'), cb.checked); });
      dlg.addEventListener('submit', function(e){ e.preventDefault(); var inp = e.target.querySelector('input'); newList(inp.value, +dlg.getAttribute('data-pid')); });
    }
    dlg.setAttribute('data-pid', pid); drawPick();
    if(!dlg.open) dlg.showModal();
  }
  function drawPick(){
    var pid = +dlg.getAttribute('data-pid');
    dlg.innerHTML = '<div class="cy-wl-dlg__in"><div class="cy-wl-dlg__hd"><p class="cy-wl-dlg__t" id="cy-wl-dlg-t">Save to list</p>'
      + '<button type="button" class="cy-wl-dlg__x" data-close aria-label="Close">&times;</button></div>'
      + '<ul class="cy-wl-dlg__ls">' + lists.map(function(l){
          return '<li><label class="cy-wl-dlg__row"><input type="checkbox" data-list="' + esc(l.id) + '"' + (has(l, pid) ? ' checked' : '') + '><span>' + esc(l.name) + '</span><em>' + l.items.length + '</em></label></li>';
        }).join('') + '</ul>'
      + (lists.length < MAX_LISTS ? '<form class="cy-wl-dlg__new"><input type="text" maxlength="40" required placeholder="New list name" aria-label="New list name"><button type="submit" class="cy-btn">Create</button></form>' : '')
      + '<button type="button" class="cy-btn cy-btn--ghost-dk cy-wl-dlg__done" data-close>Done</button></div>';
  }
  function pickCounts(){   // update the open picker in place - a full redraw would drop keyboard focus
    if(!dlg || !dlg.open) return;
    var pid = +dlg.getAttribute('data-pid');
    lists.forEach(function(l){ var cb = dlg.querySelector('input[data-list="' + l.id + '"]'); if(!cb) return; cb.checked = has(l, pid); cb.parentNode.querySelector('em').textContent = l.items.length; });
  }
  function member(pid, lid, on){
    var before = snapshot(), l = lists.filter(function(x){ return x.id === lid; })[0]; if(!l) return;
    if(on){ if(!has(l, pid)) l.items.unshift([pid, now()]); } else { l.items = l.items.filter(function(it){ return it[0] !== pid; }); }
    paint(); renderPage(); pickCounts();
    send({op: on ? 'add' : 'remove', pid: pid, list: lid}).then(took).catch(function(e){ restore(before); oops(e); });
  }
  function newList(name, pid){
    name = (name || '').trim(); if(!name) return;
    send({op:'create', name: name}).then(function(j){
      took(j); active = j.created; if(dlg && dlg.open) drawPick();
      return pid ? send({op:'add', pid: pid, list: j.created}).then(function(j2){ took(j2); toast('Saved to ' + name); }) : toast('List created');
    }).catch(oops);
  }

  /* guest list -> account, once they are logged in */
  function merge(){
    if(!IN) return;
    var g = guest(), ids = Object.keys(g); if(!ids.length) return;
    ids.forEach(function(id){ if(g[id].handle) handles[+id] = g[id].handle; });
    var pids = ids.map(Number).filter(function(p){ return p && !saved(p); });
    if(!pids.length){ guestSave({}); return; }
    send({op:'merge', pids: pids}).then(function(j){
      guestSave({}); took(j);
      toast(pids.length + (pids.length === 1 ? ' item' : ' items') + ' saved on this device moved to your account wishlist');
    }).catch(function(){});
  }

  /* ---------- Cherry Rewards (points) ---------- */
  var RW = S.rw || null;                                  // {pts, joined} for a logged-in customer
  function ptsPaint(el){                                  // "Earn N points": 1 per A$2, so convert other currencies back to A$
    var rate = +(window.Shopify && Shopify.currency && Shopify.currency.rate) || 1;
    var n = Math.floor((+el.getAttribute('data-price') || 0) / 100 / rate * 0.5 * (+el.getAttribute('data-mult') || 1));
    var b = el.querySelector('[data-cy-pts-n]'); if(b) setText(b, String(n));
    el.hidden = n < 1;
  }
  window.cyPointsPaint = ptsPaint;
  function rwShow(j){
    [].forEach.call(document.querySelectorAll('[data-cy-rw-pts]'), function(el){ setText(el, String(j.pts)); });
    [].forEach.call(document.querySelectorAll('[data-cy-rw-redeem]'), function(b){ b.disabled = j.pts < +b.getAttribute('data-cy-rw-redeem'); });
  }
  function rwJoin(){                                      // first logged-in visit: the 50-point welcome (once - the backend checks too)
    if(!IN || !RW || RW.joined) return;
    try { if(sessionStorage.getItem('cyRwJoin')) return; sessionStorage.setItem('cyRwJoin', '1'); } catch(e){}
    send({op:'join'}, '/apps/cherry/loyalty').then(function(j){ if(j.joined_now){ rwShow(j); toast('Welcome to Cherry Rewards: 50 points added'); } }).catch(function(){});
  }
  function rwRedeem(btn){
    var cost = +btn.getAttribute('data-cy-rw-redeem'), pct = btn.getAttribute('data-pct') || '';
    if(!window.confirm('Use ' + cost + ' points for ' + pct + ' off your next order?')) return;
    btn.disabled = true;
    send({op:'redeem', cost: cost}, '/apps/cherry/loyalty').then(function(j){
      rwShow(j);
      var box = document.getElementById('cy-rw-code');
      if(box){
        box.innerHTML = '<p class="cy-rw-code-t">Your ' + esc(j.pct) + '% off code</p><p class="cy-rw-code-c">' + esc(j.code) + '</p>'
          + '<p>Valid until ' + esc(new Date(j.until + 'T00:00:00').toLocaleDateString('en-AU', {day:'numeric', month:'short', year:'numeric'})) + '. Works once, on your account.</p>'
          + '<div class="cy-cta"><a class="cy-btn" href="/discount/' + encodeURIComponent(j.code) + '?redirect=/cart">Apply to my cart</a>'
          + '<button type="button" class="cy-btn cy-btn--ghost-dk" data-cy-rw-copy="' + esc(j.code) + '">Copy code</button></div>';
        box.hidden = false; box.scrollIntoView({behavior:'smooth', block:'center'});
      }
      toast('Reward code created');
    }).catch(function(e){ btn.disabled = false; toast(e && e.message === 'not enough points' ? 'Not enough points for that reward yet.' : "Couldn't create your reward. Please try again."); });
  }

  /* ---------- wishlist page ---------- */
  var cache = {};
  function fetchP(h){
    return cache[h] || (cache[h] = fetch(ROOT + 'products/' + encodeURIComponent(h) + '.js', {headers:{'Accept':'application/json'}})
      .then(function(r){ return r.ok ? r.json() : null; }).catch(function(){ return null; }));
  }
  function money(cents){
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'AUD';
    var loc = {AUD:'en-AU', USD:'en-US', NZD:'en-NZ', CAD:'en-CA', GBP:'en-GB'}[cur] || document.documentElement.lang || 'en';   // '$' in each home market, as Liquid's money filter shows
    try { return new Intl.NumberFormat(loc, {style:'currency', currency: cur}).format(cents / 100); }
    catch(e){ return '$' + (cents / 100).toFixed(2); }
  }
  function shape(p){
    var vs = p.variants || [], v = vs.filter(function(x){ return x.available; })[0] || vs[0] || {};
    var img = p.featured_image ? p.featured_image + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=500' : '';
    return {h: p.handle, t: p.title, u: ROOT + 'products/' + p.handle, i: img, p: money(p.price),
            c: p.compare_at_price > p.price ? money(p.compare_at_price) : '', a: p.available, v: v.id, m: vs.length > 1};
  }
  function ensureData(cb){
    if(!data){ data = {}; try { data = JSON.parse((document.getElementById('cy-wl-products') || {}).textContent || '{}') || {}; } catch(e){} }
    var need = [];
    lists.forEach(function(l){ l.items.forEach(function(it){ var h = handles[it[0]]; if(!data[it[0]] && h && need.indexOf(h) < 0) need.push(h); }); });
    if(!need.length) return cb();
    Promise.all(need.map(fetchP)).then(function(ps){ ps.forEach(function(p){ if(p) data[p.id] = shape(p); }); cb(); });
  }
  function card(pid, d, own){
    var act = !d.a ? '<p class="cy-wl-na">Currently unavailable</p><a class="cy-btn cy-btn--ghost-dk cy-wl-go" href="' + esc(d.u) + '">View product</a>'
      : d.m ? '<a class="cy-btn cy-btn--ghost-dk cy-wl-go" href="' + esc(d.u) + '">Choose options</a>'
      : '<button type="button" class="cy-btn cy-wl-add" data-cy-wl-add data-variant="' + esc(d.v) + '">Add to cart</button>';
    var heart = own
      ? '<button type="button" class="cy-heart is-saved cy-wl-rm" data-cy-wl-rm="' + pid + '" aria-label="Remove ' + esc(d.t) + '">' + HEART + '</button>'
      : '<button type="button" class="cy-heart cy-wl-rm" data-cy-wl data-id="' + pid + '" data-handle="' + esc(d.h) + '" aria-pressed="false" aria-label="Save ' + esc(d.t) + ' to your wishlist">' + HEART + '</button>';
    return '<div class="cy-wl-card">' + heart
      + '<a class="cy-wl-img" href="' + esc(d.u) + '" tabindex="-1" aria-hidden="true">' + (d.i ? '<img src="' + esc(d.i) + '" alt="" loading="lazy" width="500" height="500">' : '') + '</a>'
      + '<div class="cy-wl-bd"><a class="cy-wl-t" href="' + esc(d.u) + '">' + esc(d.t) + '</a>'
      + '<div class="cy-wl-pr">' + esc(d.p) + (d.c ? ' <s>' + esc(d.c) + '</s>' : '') + '</div>' + act + '</div></div>';
  }
  function legacyCard(x){
    return '<div class="cy-wl-card cy-wl-card--legacy">'
      + '<button type="button" class="cy-heart is-saved cy-wl-rm" data-cy-wl-rm="' + x.p + '" aria-label="Remove ' + esc(x.t) + '">' + HEART + '</button>'
      + '<div class="cy-wl-img">' + (x.i ? '<img src="' + esc(x.i) + '" alt="" loading="lazy" width="500" height="500">' : '') + '</div>'
      + '<div class="cy-wl-bd"><p class="cy-wl-t">' + esc(x.t) + '</p><p class="cy-wl-na">No longer available online</p>'
      + '<a class="cy-btn cy-btn--ghost-dk cy-wl-go" href="/pages/contact-us?ref=' + encodeURIComponent(x.t) + '">Ask us about it</a></div></div>';
  }
  function renderPage(){
    var root = document.getElementById('cy-wishlist-root'); if(!root || shareMode) return;
    if(active === null && legacy.length && !total()) active = 'legacy';          // only old saves: open on them
    if(active === 'legacy' && !legacy.length) active = null;
    var isLegacy = active === 'legacy';
    var l = isLegacy ? null : (lists.filter(function(x){ return x.id === active; })[0] || lists[0]);
    if(l) active = l.id;
    ensureData(function(){
      var html = '';
      if(IN){
        html += '<div class="cy-wl-tabs" role="tablist" aria-label="Your lists">' + lists.map(function(x){
            return '<button type="button" role="tab" class="cy-wl-tab' + (x.id === active ? ' is-on' : '') + '" aria-selected="' + (x.id === active) + '" data-cy-wl-tab="' + esc(x.id) + '">' + esc(x.name) + ' <em>' + x.items.length + '</em></button>';
          }).join('')
          + (legacy.length ? '<button type="button" role="tab" class="cy-wl-tab' + (isLegacy ? ' is-on' : '') + '" aria-selected="' + isLegacy + '" data-cy-wl-tab="legacy">Legacy Wishlist <em>' + legacy.length + '</em></button>' : '')
          + (lists.length < MAX_LISTS ? '<button type="button" class="cy-wl-tab cy-wl-tab--new" data-cy-wl-act="new">+ New list</button>' : '') + '</div>'
          + (isLegacy
            ? '<p class="cy-wl-legacy-note">Saved on our old wishlist. These products are no longer sold online. Tap &ldquo;Ask us about it&rdquo; if you are still after one.</p><div class="cy-wl-bar"><button type="button" data-cy-wl-act="delete">Delete list</button></div>'
            : '<div class="cy-wl-bar"><button type="button" data-cy-wl-act="share">Share this list</button><button type="button" data-cy-wl-act="rename">Rename</button><button type="button" data-cy-wl-act="delete">Delete list</button></div>');
      } else {
        html += '<div class="cy-wl-note"><p>' + esc(root.getAttribute('data-guest-note')) + '</p><a class="cy-btn" href="' + esc(S.login || '/account/login') + '">Log in</a></div>';
      }
      var cards = isLegacy ? legacy.map(legacyCard).join('') : l.items.map(function(it){ var d = data[it[0]]; return d ? card(it[0], d, true) : ''; }).join('');
      html += cards ? '<div class="cy-wl-grid">' + cards + '</div>' : '<div class="cy-wl-empty"><p>' + esc(root.getAttribute('data-empty')) + '</p></div>';
      root.innerHTML = html;
    });
  }
  function removeFrom(pid){
    if(active === 'legacy'){
      var old = JSON.stringify(legacy);
      legacy = legacy.filter(function(x){ return x.p !== pid; }); renderPage();
      send({op:'remove', pid: pid, list:'legacy'}).then(took).catch(function(e){ legacy = JSON.parse(old); renderPage(); oops(e); });
      return;
    }
    var before = snapshot(), multi = IN && lists.length > 1;
    lists.forEach(function(l){ if(!multi || l.id === active) l.items = l.items.filter(function(it){ return it[0] !== pid; }); });
    paint(); renderPage();
    if(!IN){ var g = guest(); delete g[pid]; guestSave(g); return; }
    send(multi ? {op:'remove', pid: pid, list: active} : {op:'remove', pid: pid}).then(took).catch(function(e){ restore(before); oops(e); });
  }
  function listAction(act){
    if(active === 'legacy' && act === 'delete'){
      if(window.confirm('Delete your Legacy Wishlist? These products are no longer sold online.')) send({op:'delete', list:'legacy'}).then(function(j){ active = null; took(j); toast('List deleted'); }).catch(oops);
      return;
    }
    var l = lists.filter(function(x){ return x.id === active; })[0] || lists[0];
    if(act === 'new'){ var n = window.prompt('Name your new list'); if(n) newList(n); return; }
    if(act === 'rename'){ var r = window.prompt('Rename this list', l.name); if(r && r.trim()) send({op:'rename', list: l.id, name: r.trim()}).then(took).catch(oops); return; }
    if(act === 'delete'){ if(window.confirm('Delete "' + l.name + '"? Products in your other lists stay saved.')) send({op:'delete', list: l.id}).then(function(j){ active = null; took(j); toast('List deleted'); }).catch(oops); return; }
    if(act === 'share'){
      send({op:'share', list: l.id}).then(function(j){
        var url = location.origin + location.pathname + '?share=' + encodeURIComponent(j.token);
        if(navigator.share) return navigator.share({title: l.name, text: 'My Cherry Tuning wishlist: ' + l.name, url: url}).catch(function(){});
        if(navigator.clipboard) return navigator.clipboard.writeText(url).then(function(){ toast('Link copied. Anyone with it can view this list.'); }, function(){ window.prompt('Copy this link', url); });
        window.prompt('Copy this link', url);
      }).catch(oops);
    }
  }
  function shareView(token){
    var root = document.getElementById('cy-wishlist-root'); shareMode = true;
    root.innerHTML = '<div class="cy-wl-empty"><p>Loading the shared list&hellip;</p></div>';
    fetch(SHARE_API + '?t=' + encodeURIComponent(token), {headers:{'Accept':'application/json'}})
      .then(function(r){ return r.json(); })
      .then(function(j){
        if(!j.ok) throw new Error(j.error);
        [['[data-cy-wl-eyebrow]', 'Shared wishlist'], ['[data-cy-wl-heading]', j.name], ['[data-cy-wl-lead]', 'Someone shared this list with you. Tap a heart to save anything to your own wishlist.']]
          .forEach(function(x){ var el = document.querySelector(x[0]); if(el) el.textContent = x[1]; });
        return Promise.all(j.handles.map(fetchP)).then(function(ps){
          var html = ps.map(function(p){ return p ? card(p.id, shape(p), false) : ''; }).join('');
          root.innerHTML = html ? '<div class="cy-wl-grid">' + html + '</div>' : '<div class="cy-wl-empty"><p>This list is empty.</p></div>';
          paint(root);
        });
      })
      .catch(function(){ root.innerHTML = '<div class="cy-wl-empty"><p>This share link is not valid any more.</p></div>'; });
  }
  function addToCart(btn){
    var vid = btn.getAttribute('data-variant'); if(!vid) return;
    btn.disabled = true; btn.setAttribute('aria-busy', 'true');
    var fd = new FormData(); fd.append('id', vid); fd.append('quantity', '1'); fd.append('sections', 'mini-cart');
    function done(){ btn.disabled = false; btn.removeAttribute('aria-busy'); }
    fetch(ROOT + 'cart/add.js', {method:'POST', body: fd, headers:{'X-Requested-With':'XMLHttpRequest'}})
      .then(function(r){ return r.json().then(function(j){ return {ok: r.ok, j: j}; }); })
      .then(function(res){
        done();
        if(!res.ok){ toast((res.j && (res.j.description || res.j.message)) || 'Sorry, this could not be added.'); return; }
        btn.textContent = 'Added ✓'; setTimeout(function(){ btn.textContent = 'Add to cart'; }, 2200);
        toast('Added to cart');   // this theme uses the cart page (no drawer), so say so here
        return fetch(ROOT + 'cart.js').then(function(r){ return r.json(); }).then(function(cart){   // Focal's drawer listens for these
          document.documentElement.dispatchEvent(new CustomEvent('cart:updated', {bubbles: true, detail: {cart: cart}}));
          cart.sections = res.j.sections;
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {bubbles: true, detail: {cart: cart, openMiniCart: true}}));
        });
      })
      .catch(function(){ done(); toast('Network error. Please try again.'); });
  }

  document.addEventListener('click', function(e){
    var t = e.target && e.target.closest ? e.target : null, b; if(!t) return;
    if(dlg && dlg.contains(t)) return;                                   // the picker handles its own clicks
    if((b = t.closest('[data-cy-rw-redeem]'))){ e.preventDefault(); if(!b.disabled) rwRedeem(b); return; }
    if((b = t.closest('[data-cy-rw-copy]'))){ e.preventDefault(); var c = b.getAttribute('data-cy-rw-copy'); if(navigator.clipboard) navigator.clipboard.writeText(c).then(function(){ toast('Code copied'); }); else window.prompt('Copy your code', c); return; }
    if((b = t.closest('[data-cy-wl-pick]'))){ e.preventDefault(); pick(+b.getAttribute('data-id')); return; }
    if((b = t.closest('[data-cy-wl-rm]'))){ e.preventDefault(); removeFrom(+b.getAttribute('data-cy-wl-rm')); return; }
    if((b = t.closest('[data-cy-wl-add]'))){ e.preventDefault(); addToCart(b); return; }
    if((b = t.closest('[data-cy-wl-tab]'))){ active = b.getAttribute('data-cy-wl-tab'); renderPage(); return; }
    if((b = t.closest('[data-cy-wl-act]'))){ listAction(b.getAttribute('data-cy-wl-act')); return; }
    if((b = t.closest('[data-cy-wl]'))){ e.preventDefault(); toggle(b); }
  });

  function init(){
    paint();
    var tok = /[?&]share=([^&#]+)/.exec(location.search);
    if(tok && document.getElementById('cy-wishlist-root')) shareView(decodeURIComponent(tok[1])); else renderPage();
    merge();
    rwJoin();
    [].forEach.call(document.querySelectorAll('[data-cy-pts]'), ptsPaint);
    // cards/buttons re-rendered by the theme (filters, variant change, quick view) get painted too
    var queued = false;
    new MutationObserver(function(){ if(queued) return; queued = true; requestAnimationFrame(function(){ queued = false; paint(); }); })
      .observe(document.body, {childList: true, subtree: true});
  }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function(e){ paint(e.target); renderPage(); });
})();
